export { ImageEditor } from './ImageEditor';
export type { AspectOption } from './ImageEditor';
export { ImageEditorModal } from './ImageEditorModal';
export { useImageEditorUpload } from './useImageEditorUpload';

import type { AspectOption } from './ImageEditor';

export const DEFAULT_ASPECT_OPTIONS: AspectOption[] = [
    { label: 'Free', value: undefined },
    { label: '1:1', value: 1 },
    { label: '4:3', value: 4 / 3 },
    { label: '16:9', value: 16 / 9 },
    { label: '16:6', value: 16 / 6 },
];
